import React from 'react';
import { Link } from 'react-router-dom';

const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || 'sarunashelse@gmail.com';

const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://sarunashelse.live';

const LAST_UPDATED = '2026-09-17';

export default function PrivacyPolicyPage() {
  return (
    <div className="page legal-page">
      <div className="card legal-card">
        <h1>Privatumo politika</h1>
        <p className="legal-meta">
          Programėlė „Išgerk vaistus“ · Atnaujinta {LAST_UPDATED}
        </p>

        <section>
          <h2>1. Įvadas</h2>
          <p>
            Ši privatumo politika paaiškina, kokius jūsų duomenis renka mobilioji
            programėlė <strong>Išgerk vaistus</strong> (toliau – Programėlė) ir
            susijęs mokėjimų puslapis internete, kaip juos naudojame ir kokias
            teises turite.
          </p>
          <p>
            Naudodamiesi Programėle arba mokėdami už prenumeratą, sutinkate su šia
            politika.
          </p>
        </section>

        <section>
          <h2>2. Duomenų valdytojas</h2>
          <p>
            Už jūsų duomenų tvarkymą atsakingas Programėlės kūrėjas (duomenų
            valdytojas).
          </p>
          <p>
            Svetainė:{' '}
            <a href={SITE_URL} target="_blank" rel="noopener noreferrer">
              sarunashelse.live
            </a>
          </p>
          <p>
            Susisiekti dėl privatumo klausimų:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </section>

        <section>
          <h2>3. Kokius duomenis renkame</h2>
          <h3>Paskyros duomenys</h3>
          <ul>
            <li>El. pašto adresas (registracijai ir prisijungimui)</li>
            <li>Slaptažodis (saugomas ir tvarkomas per Firebase Authentication; mes jo nematome)</li>
            <li>Paskyros identifikatorius (Firebase UID)</li>
          </ul>

          <h3>Prenumeratos duomenys</h3>
          <ul>
            <li>Prenumeratos būsena (bandomasis laikotarpis, aktyvi, pasibaigusi)</li>
            <li>Bandomojo laikotarpio pradžios ir pabaigos datos</li>
            <li>Stripe kliento ir prenumeratos identifikatoriai (mokėjimų valdymui)</li>
          </ul>

          <h3>Priminimų duomenys</h3>
          <p>
            Jūsų įvesti vaistų priminimai (pavadinimas, laikas, savaitės dienos)
            saugomi telefone ir kopijuojami į jūsų Firebase paskyrą, kad po
            perinstaliavimo ar naujame telefone juos būtų galima atkurti. Kasdienė
            būsena („Išgėriau“) taip pat sinchronizuojama su jūsų paskyra.
          </p>

          <h3>Mokėjimo duomenys</h3>
          <p>
            Kortelės numerį ir kitus mokėjimo duomenis tvarko <strong>Stripe</strong>.
            Mes nesauname ir neturime prieigos prie jūsų pilnų mokėjimo kortelės
            duomenų.
          </p>

          <h3>Techniniai duomenys</h3>
          <ul>
            <li>
              Pranešimų leidimas telefone (kad galėtume siųsti vaistų priminimus)
            </li>
            <li>
              Standartiniai serverių ir paslaugų teikėjų techniniai žurnalai
              (klaidų diagnostikai ir saugumui)
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Kaip naudojame duomenis</h2>
          <ul>
            <li>Leisti jums prisijungti ir naudotis Programėle</li>
            <li>Valdyti 7 dienų bandomąjį laikotarpį ir prenumeratą</li>
            <li>Apdoroti mokėjimus per Stripe</li>
            <li>Siųsti vietinius priminimus jūsų telefone (pagal jūsų nustatymus)</li>
            <li>Ginčyti mokėjimus, spręsti technines problemas ir užtikrinti saugumą</li>
          </ul>
        </section>

        <section>
          <h2>5. Teisinis pagrindas (BDAR)</h2>
          <ul>
            <li>
              <strong>Sutarties vykdymas</strong> – kad galėtumėte naudotis
              Programėle ir prenumerata
            </li>
            <li>
              <strong>Teisėtas interesas</strong> – saugumui, sukčiavimo prevencijai
              ir techniniam Programėlės veikimui
            </li>
            <li>
              <strong>Teisinė prievolė</strong> – kai to reikalauja įstatymai
              (pvz., apskaita)
            </li>
            <li>
              <strong>Sutikimas</strong> – pranešimų leidimui telefone (galite
              atšaukti telefono nustatymuose)
            </li>
          </ul>
        </section>

        <section>
          <h2>6. Su kuo dalijamės duomenimis</h2>
          <p>
            Jūsų duomenis perduodame tik patikimiems paslaugų teikėjams, kurie
            padeda Programėlei veikti:
          </p>
          <ul>
            <li>
              <strong>Google Firebase</strong> – paskyros autentifikavimas ir
              prenumeratos būsena (serveriai gali būti už ES ribų; taikomos
              Google saugumo priemonės)
            </li>
            <li>
              <strong>Stripe</strong> – mokėjimų apdorojimas (
              <a
                href="https://stripe.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stripe privatumo politika
              </a>
              )
            </li>
            <li>
              <strong>Vercel</strong> – mokėjimų puslapio talpinimas internete
            </li>
          </ul>
          <p>Mes neparduodame jūsų duomenų trečiosioms šalims.</p>
        </section>

        <section>
          <h2>7. Kiek laiko saugome duomenis</h2>
          <ul>
            <li>
              Paskyros duomenys – kol turite aktyvią paskyrą arba kol paprašote
              ištrinti
            </li>
            <li>
              Mokėjimų įrašai – pagal Stripe ir teisės aktų reikalavimus (paprastai
              iki 10 metų apskaitos tikslais)
            </li>
            <li>
              Priminimai ir dienos būsena – kol turite paskyrą arba kol
              paprašote ištrinti; telefone – kol pašalinate Programėlę
            </li>
          </ul>
        </section>

        <section>
          <h2>8. Jūsų teisės</h2>
          <p>Pagal BDAR turite teisę:</p>
          <ul>
            <li>Gauti informaciją apie savo duomenis</li>
            <li>Prašyti ištaisyti netikslius duomenis</li>
            <li>Prašyti ištrinti paskyrą ir susijusius duomenis</li>
            <li>Apriboti arba nesutikti su tam tikru duomenų tvarkymu</li>
            <li>Gauti duomenų kopiją (perkeliamumas)</li>
            <li>Pateikti skundą Valstybinei duomenų apsaugos inspekcijai (VDAI)</li>
          </ul>
          <p>
            Prašymams įvykdyti rašykite:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. Atsakysime per
            30 dienų.
          </p>
        </section>

        <section>
          <h2>9. Paskyros ištrynimas</h2>
          <p>
            Paskyrą galite ištrinti programėlėje (Pagalba → Ištrinti paskyrą)
            arba svetainėje{' '}
            <a href={`${SITE_URL}/delete-account`}>{SITE_URL}/delete-account</a>.
            Taip pat galite parašyti{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> iš to el.
            pašto, kuriuo registravotės.
          </p>
          <p>
            Jei Stripe prenumerata vis dar aktyvi arba gali būti toliau
            apmokestinama, paskyros neištrinsime, kol jos nenutrauksite
            (programėlėje: Pagalba → Tvarkyti prenumeratą).
          </p>
          <p>
            Ištrynus paskyrą pašaliname Firebase Authentication paskyrą,
            Firestore profilį, priminimus ir dienos būseną. Stripe mokėjimų
            istorijos nenaikiname – ją saugo Stripe pagal teisės aktus.
          </p>
        </section>

        <section>
          <h2>10. Vaikų privatumas</h2>
          <p>
            Programėlė skirta suaugusiems ir vyresnio amžiaus žmonėms. Sąmoningai
            nerenkame jaunesnių nei 16 metų vaikų duomenų. Jei sužinotume, kad
            surinkome tokį duomenį, jį ištrintume.
          </p>
        </section>

        <section>
          <h2>11. Saugumas</h2>
          <p>
            Naudojame pramonės standartus atitinkančias priemones (šifruotas ryšys,
            Firebase ir Stripe saugumo mechanizmai). Vis dėlto joks perdavimas
            internetu nėra 100 % saugus.
          </p>
        </section>

        <section>
          <h2>12. Politikos pakeitimai</h2>
          <p>
            Šią politiką galime atnaujinti. Apie svarbius pakeitimus informuosime
            Programėlėje arba el. paštu. Naujausia versija visada bus šiame
            puslapyje.
          </p>
        </section>

        <section>
          <h2>13. Kontaktai</h2>
          <p>
            Svetainė:{' '}
            <a href={SITE_URL} target="_blank" rel="noopener noreferrer">
              sarunashelse.live
            </a>
          </p>
          <p>
            Privatumo klausimais:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </section>

        <p className="legal-back">
          <Link to="/">← Pradžia</Link>
        </p>
      </div>
    </div>
  );
}
